<template>
  <v-row>
    <v-progress-linear :active="isLoading" color="loader" indeterminate />
    <v-col cols="10">
      <text-view
          v-for="subscription in subscriptions"
          :key="subscription.subscriptionsType"
          :display="$t(subscription.enabled
            ?'Да'
            :'Нет')"
          :label="subscription.description" />
    </v-col>
    <v-col cols="1">
      <btn-icon-tip
          v-if="isAdmin && !isLoading"
          icon-color="primary"
          icon="edit"
          :tip="$t('Редактировать')"
          @click="openSubscriptionsDialog" />
      <subscriptions-dialog
          v-if="subscriptionsDialog.show"
          :mailing="mailing"
          :dialog-prop="subscriptionsDialog"
          @close="closeDialog('subscriptionsDialog')" />
    </v-col>
  </v-row>
</template>

<script>
  import SubscriptionsDialog from '@/components/reused/common/SubscriptionsDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      SubscriptionsDialog,
      TextView,
      BtnIconTip
    },
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false,
        subscriptionsDialog: {
          show: false,
          callback: null
        }
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        mailing: state => (state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] || {})
      }),
      subscriptions () {
        return this.mailing?.subscriptions?.map(m => ({
          ...m,
          enabled: !m.disabled
        })) || []
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.userId) {
          return
        }
        vm.getUserSubscription()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.GET_USER_SUBSCRIPTION,
        changeUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.CHANGE_USER_SUBSCRIPTION,
        clearUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_SUBSCRIPTION
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserSubscriptionAction()
          ])
      },
      getUserSubscription: async function () {
        this.isLoading = true
        try {
          await this.getUserSubscriptionAction({
            userId: this.userId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openSubscriptionsDialog: async function () {
        this.subscriptionsDialog.callback = this.changeUserSubscription
        this.subscriptionsDialog.show = true
      },
      changeUserSubscription: async function (subscriptions) {
        this.isLoading = true
        try {
          await this.changeUserSubscriptionAction({
            userId: this.userId,
            subscriptions
          })

          this.$emit('edited')
          await this.getUserSubscription()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
